// @flow

import React, { PureComponent } from "react";
import styled from "styled-components";

const SVG = styled.svg`
  display: block;
  height: 135px;
`;

export default class CarrerFirst extends PureComponent<*> {
  render() {
    let windowLocation = "";
    if (typeof window !== "undefined") {
      windowLocation = window.location.href;
    }
    return (
      <SVG viewBox="0 0 374 134">
        <defs>
          <filter
            x="-.1%"
            y="-.4%"
            width="100.3%"
            height="100.7%"
            filterUnits="objectBoundingBox"
            id="b"
          >
            <feOffset dy="-1" in="SourceAlpha" result="shadowOffsetInner1" />
            <feComposite
              in="shadowOffsetInner1"
              in2="SourceAlpha"
              operator="arithmetic"
              k2="-1"
              k3="1"
              result="shadowInnerInner1"
            />
            <feColorMatrix
              values="0 0 0 0 0.811764706 0 0 0 0 0.839215686 0 0 0 0 0.858823529 0 0 0 1 0"
              in="shadowInnerInner1"
            />
          </filter>
          <filter
            x="0%"
            y="0%"
            width="100%"
            height="100%"
            filterUnits="objectBoundingBox"
            id="d"
          >
            <feGaussianBlur in="SourceGraphic" />
          </filter>
          <linearGradient x1="0%" y1="39.875%" x2="88.738%" y2="60.996%" id="c">
            <stop stopColor="#FFCB4D" offset="0%" />
            <stop stopColor="#FFD87A" offset="53.328%" />
            <stop stopColor="#FFCB4D" offset="53.692%" />
            <stop stopColor="#FFCB4D" offset="100%" />
          </linearGradient>
          <path id="a" d="M0 0h375v134H0z" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <use fill="#F8FBFF" />
          <use fill="#000" filter={`url(${windowLocation}#b)`} />
          <text
            stroke="#31A0FD"
            opacity=".4"
            fontFamily="Shentox-Bold, Shentox"
            fontSize="40"
            fontWeight="bold"
            fill="#EBF6FF"
          >
            <tspan x="12" y="87">
              2ND
            </tspan>
          </text>
          <text
            stroke="#1493FF"
            opacity=".4"
            fontFamily="Shentox-Bold, Shentox"
            fontSize="40"
            fontWeight="bold"
            fill="#EBF6FF"
          >
            <tspan x="290" y="87">
              3RD
            </tspan>
          </text>
          <g transform="translate(248 39)" fillRule="nonzero">
            <circle
              fill="#FFCB4D"
              opacity=".6"
              transform="matrix(-1 0 0 1 56.41 0)"
              cx="28.205"
              cy="53.846"
              r="2.564"
            />
            <circle
              fill="#FFCB4D"
              transform="matrix(-1 0 0 1 7.692 0)"
              cx="3.846"
              cy="19.231"
              r="3.846"
            />
            <circle
              fill="#FFCB4D"
              opacity=".5"
              transform="matrix(-1 0 0 1 82.051 0)"
              cx="41.026"
              cy="5.128"
              r="5.128"
            />
            <path
              d="M18.783 7.692c10.815 3.168 4.374 13.039 4.374 13.039s-7.652-2.582-4.374-13.039zm1.1 25.822c-.315-.143-7.875-3.503-5.29-11.757 0 0 7.804.539 6.305 8.662 1.311-3.005 4.134-7.242 9.844-8.156.654 16.043-10.859 11.25-10.859 11.25zm-8.79-1.195c-5.2 8.098 1.72 13.384 1.856 13.49.166.135 9.789 7.957 14.113-7.47-5.32-.726-9.234 1.933-11.574 4.274 3.312-7.722-4.395-10.294-4.395-10.294zM4.71 52.12c-.006.004-.012.012-.018.017.418-.145.865-.283 1.336-.41 3.292-.887 7.77-1.175 11.908 1.65.009.007.018.012.027.02-11.698 12.34-16.82.365-16.818.36a12.554 12.554 0 01-.42-.997c-.998-2.686-1.82-7.757 3.664-11.881 0 0 6.385 5.058.32 11.24z"
              fill="#2CB459"
            />
          </g>
          <g transform="matrix(-1 0 0 1 128 38)" fillRule="nonzero">
            <circle
              fill="#FFCB4D"
              opacity=".6"
              transform="matrix(-1 0 0 1 56.41 0)"
              cx="28.205"
              cy="53.846"
              r="2.564"
            />
            <circle
              fill="#FFCB4D"
              transform="matrix(-1 0 0 1 7.692 0)"
              cx="3.846"
              cy="19.231"
              r="3.846"
            />
            <circle
              fill="#FFCB4D"
              opacity=".5"
              transform="matrix(-1 0 0 1 82.051 0)"
              cx="41.026"
              cy="5.128"
              r="5.128"
            />
            <path
              d="M19.783 8.692c10.815 3.168 4.374 13.039 4.374 13.039s-7.652-2.582-4.374-13.039zm1.1 25.822c-.315-.143-7.875-3.503-5.29-11.757 0 0 7.804.539 6.305 8.662 1.311-3.005 4.134-7.242 9.844-8.156.654 16.043-10.859 11.25-10.859 11.25zm-8.79-1.195c-5.2 8.098 1.72 13.384 1.856 13.49.166.135 9.789 7.957 14.113-7.47-5.32-.726-9.234 1.933-11.574 4.274 3.312-7.722-4.395-10.294-4.395-10.294zM5.71 53.12c-.006.004-.012.012-.018.017.418-.145.865-.283 1.336-.41 3.292-.887 7.77-1.175 11.908 1.65.009.007.018.012.027.02-11.698 12.34-16.82.365-16.818.36a12.554 12.554 0 01-.42-.997c-.998-2.686-1.82-7.757 3.664-11.881 0 0 6.385 5.058.32 11.24z"
              fill="#BBF0CD"
            />
            <path
              d="M18.783 7.692c10.815 3.168 4.374 13.039 4.374 13.039s-7.652-2.582-4.374-13.039zm1.1 25.822c-.315-.143-7.875-3.503-5.29-11.757 0 0 7.804.539 6.305 8.662 1.311-3.005 4.134-7.242 9.844-8.156.654 16.043-10.859 11.25-10.859 11.25zm-8.79-1.195c-5.2 8.098 1.72 13.384 1.856 13.49.166.135 9.789 7.957 14.113-7.47-5.32-.726-9.234 1.933-11.574 4.274 3.312-7.722-4.395-10.294-4.395-10.294zM4.71 52.12c-.006.004-.012.012-.018.017.418-.145.865-.283 1.336-.41 3.292-.887 7.77-1.175 11.908 1.65.009.007.018.012.027.02-11.698 12.34-16.82.365-16.818.36a12.554 12.554 0 01-.42-.997c-.998-2.686-1.82-7.757 3.664-11.881 0 0 6.385 5.058.32 11.24z"
              fill="#2CB459"
            />
          </g>
          <path
            d="M171.041 86.796H148v-6.792h7.784V57.996H148v-6.792h15.67v28.8h7.371v6.792zm3.35-22.928v-5.362c0-2.417.654-4.272 1.96-5.566 1.305-1.293 3.178-1.94 5.618-1.94h10.052c2.37 0 4.192.647 5.464 1.94 1.271 1.294 1.907 3.15 1.907 5.566v3.524h-7.784v-3.217c0-.851-.43-1.277-1.288-1.277h-6.856c-.86 0-1.289.426-1.289 1.277v3.676c0 .477.078.809.232.996.155.187.456.349.902.485l11.444 2.91c3.367.886 5.051 2.911 5.051 6.077v6.537c0 2.417-.653 4.272-1.959 5.566-1.305 1.293-3.178 1.94-5.618 1.94h-10.773c-2.372 0-4.193-.647-5.464-1.94-1.272-1.294-1.908-3.15-1.908-5.566v-3.217h7.784v2.91c0 .851.43 1.277 1.289 1.277h7.525c.86 0 1.29-.426 1.29-1.277v-4.442c0-.75-.413-1.226-1.238-1.43l-11.753-3.013c-3.058-.783-4.587-2.928-4.587-6.434zM228 57.996h-8.454v28.8h-7.886v-28.8h-8.505v-6.792H228v6.792z"
            fill="#E8B436"
            fillRule="nonzero"
          />
          <path
            d="M171.041 84.796H148v-6.792h7.784V55.996H148v-6.792h15.67v28.8h7.371v6.792zm3.35-22.928v-5.362c0-2.417.654-4.272 1.96-5.566 1.305-1.293 3.178-1.94 5.618-1.94h10.052c2.37 0 4.192.647 5.464 1.94 1.271 1.294 1.907 3.15 1.907 5.566v3.524h-7.784v-3.217c0-.851-.43-1.277-1.288-1.277h-6.856c-.86 0-1.289.426-1.289 1.277v3.676c0 .477.078.809.232.996.155.187.456.349.902.485l11.444 2.91c3.367.886 5.051 2.911 5.051 6.077v6.537c0 2.417-.653 4.272-1.959 5.566-1.305 1.293-3.178 1.94-5.618 1.94h-10.773c-2.372 0-4.193-.647-5.464-1.94-1.272-1.294-1.908-3.15-1.908-5.566v-3.217h7.784v2.91c0 .851.43 1.277 1.289 1.277h7.525c.86 0 1.29-.426 1.29-1.277v-4.442c0-.75-.413-1.226-1.238-1.43l-11.753-3.013c-3.058-.783-4.587-2.928-4.587-6.434zM228 55.996h-8.454v28.8h-7.886v-28.8h-8.505v-6.792H228v6.792z"
            stroke="#E8B436"
            fill={`url(${windowLocation}#c)`}
            fillRule="nonzero"
          />
          <ellipse
            fill="#EBF6FF"
            filter={`url(${windowLocation}#d)`}
            cx="188"
            cy="108"
            rx="40"
            ry="3"
          />
        </g>
      </SVG>
    );
  }
}
